export default "__VITE_ASSET__Z9PDv5Lk__"